import React from "react";
import { Alert } from "antd";
import { useSelector } from "react-redux/lib/hooks/useSelector";
// eslint-disable-next-line react/prop-types
const DummyContentAlert = ({subscribed,message="Student data is hidden due for security reasons. Contact us using Chat to complete your verification process. "}) => {
    // const { teacher_details = null } = useSelector(({ dashboard }) => dashboard);
    if (subscribed) return ""
    return (<Alert
        message={message}
        type="info"
        closable
    // onClose={onClose}
    />)
}

export default DummyContentAlert